import React, { useEffect, useState } from 'react'
import NewAccModal from '../Users/NewAccModal';
import ToastMessage from '../../../common/ToastMessage';
import CustomDataGrid from '../../../common/CustomDataGrid';
import useUserWithPasswordForget from '../../../store/ReactQueries/usersWithPassword/useUserWithPasswordForget';
import useUpdateUserWithPassForget from '../../../store/ReactQueries/usersWithPassword/useUpdateUserWithPassForgStore';
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../utils/constants';
import { EndPoints } from '../../../utils/apiEndpoints';
import { FieldErrors } from '../../../domain/helpers/Errors';
import { generateNewPassword } from '../../Auth/GeneratePassword';
import { useLanguageStore } from '../../../store/useLanguageStore';
import { ForgetPasswordInterface } from '../../../domain/helpers/ForgetPassword';

export const ManageUsers = () => {

    const { language } = useLanguageStore();
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [password, setPassword] = useState<string>('');
    const [modal, setModal] = useState<boolean>(false);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<ForgetPasswordInterface>({
        id: '',
        firstname: '',
        lastname: '',
        email: '',
        forgetPassword: false,
        resetPassword: false,
    });

    const updateUser = useUpdateUserWithPassForget(page, pageSize);
    const { data: users, isLoading, error: statusError } = useUserWithPasswordForget(page, pageSize);

    useEffect(() => {
        if (statusError) ToastMessage.Failed(`Error: ${statusError.message}`);
    }, [statusError]);

    useEffect(() => {
        if (form.email !== '') {
            handleSave();
        }
    }, [form.email]);

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false, width: 150 },
        { field: 'firstname', headerName: 'Firstname', type: "string", editable: false, width: 150 },
        { field: 'lastname', headerName: 'Lastname', type: "string", editable: false, width: 150 },
        { field: 'email', headerName: 'Email', type: "string", editable: false, width: 250 },
    ];

    const handleError = (error: unknown) => {
        if (error instanceof Error) ToastMessage.Failed(error.message);
        else ToastMessage.Failed();
    };

    const handleReset = async (row: ForgetPasswordInterface) => setForm(row);

    const handleSave = async () => {
        setModal(false);
        const newPassword = generateNewPassword();
        const upForm: { email: string, password: string } = {
            email: form.email,
            password: newPassword
        };

        updateUser.mutate(upForm, {
            onSuccess: () => {
                setPassword(newPassword);
                setModal(true);
                ToastMessage.Success()
            },
            onError: (error) => handleError(error)
        });
    }

    return <React.Fragment>
        <CustomDataGrid
            name={language['ManageUsers']}
            rows={users || []}
            hideColumns={['id']}
            showColumnModal={[]}
            modal={{
                add: false,
                edit: false,
                view: false
            }}
            setModal={function (value: React.SetStateAction<{ add: boolean; edit: boolean; view: boolean; }>): void {
                throw new Error('Function not implemented.');
            }}
            addItems={() => { }}
            handleDelete={() => { }}
            page={page}
            form={form}
            errors={errors}
            columns={columns}
            loading={isLoading}
            pageSize={pageSize}
            isResetPassword
            setPage={setPage}
            setForm={setForm}
            setErrors={setErrors}
            handleSave={handleSave}
            setPageSize={setPageSize}
            handleReset={handleReset}
        />
        {modal
            && <NewAccModal
                open={modal}
                setOpen={setModal}
                email={form.email}
                password={password}
                route={EndPoints.MANAGEUSERS}
            />
        }
    </React.Fragment>
}
export default ManageUsers;